up.compiler('[sidebar-toggle]', (sidebar) => {
  let toggle = up.element.get(sidebar, '[toggle]')
  let toggleArrow = toggle.querySelector('[toggle-arrow]')
  let headline = document.querySelector('[movable-headline]')

  function toggleSidebar() {
    if (sidebar.classList.contains('-open')) {
      openSidebar()
    } else {
      closeSidebar()
    }
  }

  function openSidebar() {
    headline.classList.toggle('-left', false)
    toggleArrow.classList.add('-open')
  }

  function closeSidebar() {
    headline.classList.toggle('-left', true)
    toggleArrow.classList.remove('-open')
  }

  toggle.addEventListener('click', (event) => {
    event.preventDefault()
    sidebar.classList.toggle('-open')
    toggleSidebar()
  })

  up.on('app:sidebar:show', () => {
    sidebar.classList.toggle('-open', true)
    openSidebar()
  })

})
